var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ui-flex',[(!_vm.hideTitle)?_c('ui-cell',[_c('h3',{staticClass:"title"},[_vm._t("title",function(){return [_vm._v(_vm._s(_vm.title))]})],2)]):_vm._e(),_c('ui-cell',{attrs:{"grow":0,"push-right":""}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }